import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const email = e.target.email.value;
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwqahxqztwE0vWHp_9ps2hpW8-lyB_jitEeVV7f2ZfxxGT--T_Ec6d4lynRCLRKDaMm/exec';
    
    try {
      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          source: 'Blog Newsletter',
          timestamp: new Date().toISOString()
        })
      });
      
      alert('¡Gracias! Te has suscrito exitosamente.');
      e.target.reset();
    } catch (error) {
      console.error('Error:', error);
      alert('Hubo un error. Por favor intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 4 Artículos Modernos y Destacados
  const blogArticles = [
    {
      id: 1,
      title: "Master Spanish Conversation in 30 Days",
      subtitle: "The Ultimate Guide to Speaking Fluently",
      excerpt: "Discover the proven method that helped thousands of students achieve conversational fluency in just one month. Learn the secrets of immersive learning and practical techniques.",
      author: "María González",
      date: "January 10, 2024",
      readTime: "8 min read",
      category: "learning",
      image: "/images/spanish1.webp",
      tags: ["Conversation", "Fluency", "Speaking"],
      featured: true
    },
    {
      id: 2,
      title: "Spanish Music: Your Secret Learning Weapon",
      subtitle: "How Songs Accelerate Language Acquisition",
      excerpt: "Scientific research shows that learning through music activates multiple brain regions. Explore our curated playlist of 50 Spanish songs that will transform your learning journey.",
      author: "Carlos Rodríguez",
      date: "January 8, 2024",
      readTime: "6 min read",
      category: "music",
      image: "/images/spanish4.webp",
      tags: ["Music", "Learning Method", "Culture"],
      featured: true
    },
    {
      id: 3,
      title: "Travel Spanish: Essential Phrases for Your Trip",
      subtitle: "Communicate Confidently in Any Situation",
      excerpt: "Planning a trip to Spain or Latin America? Master these 100 essential phrases that will help you navigate airports, hotels, restaurants, and make local friends.",
      author: "Ana Martínez",
      date: "January 5, 2024",
      readTime: "10 min read",
      category: "travel",
      image: "/images/spanish3.webp",
      tags: ["Travel", "Phrases", "Practical"],
      featured: true
    },
    {
      id: 4,
      title: "Spanish Grammar Made Simple",
      subtitle: "Conquer the Subjunctive Once and For All",
      excerpt: "The subjunctive mood doesn't have to be complicated. Our step-by-step approach breaks down this challenging topic into easy-to-understand concepts with real-world examples.",
      author: "Diego Fernández",
      date: "January 3, 2024",
      readTime: "12 min read",
      category: "grammar",
      image: "/images/spanish7.webp",
      tags: ["Grammar", "Subjunctive", "Advanced"],
      featured: true
    }
  ];

  const categories = [
    { id: 'all', name: 'All Articles', color: 'from-primary-500 to-secondary-500' },
    { id: 'learning', name: 'Learning Tips', color: 'from-primary-400 to-primary-600' },
    { id: 'music', name: 'Music and Culture', color: 'from-secondary-400 to-secondary-600' },
    { id: 'travel', name: 'Travel Spanish', color: 'from-primary-500 to-secondary-500' },
    { id: 'grammar', name: 'Grammar', color: 'from-primary-600 to-secondary-600' }
  ];

  const filteredArticles = selectedCategory === 'all' 
    ? blogArticles 
    : blogArticles.filter(article => article.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* Shared Header Component */}
      <Header />

      {/* Hero Section - Mismo estilo que Home */}
      <section 
        className="relative py-24 lg:py-32 overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/spanish.learn.webp)',
          backgroundColor: '#FEF9C3'
        }}
      >
        {/* Background Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary-100/95 via-secondary-50/92 to-primary-50/95"></div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
          <h1 className="text-5xl md:text-7xl font-display font-bold text-gray-900 mb-6 leading-tight">
            Learn Spanish
            <br />
            <span className="text-primary-600">The Smart Way</span>
          </h1>
          <h2 className="text-2xl md:text-4xl font-display font-semibold text-gray-700 mb-8">
            Expert tips, cultural insights, and proven methods
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Accelerate your Spanish learning journey with our curated content
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white border-b-4 border-primary-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center transform hover:scale-105 ${
                  selectedCategory === category.id
                    ? `bg-gradient-to-r ${category.color} text-white shadow-xl`
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Articles - Modern Card Design */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4">
              Featured Articles
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-primary-600 to-secondary-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {filteredArticles.map((article, index) => (
              <article 
                key={article.id} 
                className="group bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Image Container with Overlay */}
                <div className="relative h-80 overflow-hidden">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  
                  {/* Category Badge */}
                  <div className="absolute top-4 left-4">
                    <span className={`bg-gradient-to-r ${categories.find(cat => cat.id === article.category)?.color} text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg`}>
                       {categories.find(cat => cat.id === article.category)?.name}
                    </span>
                  </div>

                  {/* Title Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl md:text-3xl font-display font-bold mb-2 drop-shadow-lg">
                      {article.title}
                    </h3>
                    <p className="text-lg text-secondary-200 font-semibold drop-shadow">
                      {article.subtitle}
                    </p>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    {article.excerpt}
                  </p>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {article.tags.map((tag, i) => (
                      <span key={i} className="bg-primary-100 text-primary-700 px-3 py-1 rounded-full text-xs font-medium">
                        #{tag}
                      </span>
                    ))}
                  </div>

                  {/* Meta Info */}
                  <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                    <div className="flex items-center space-x-4 text-sm text-gray-600">
                      <span className="flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                        {article.author}
                      </span>
                      <span className="flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        {article.readTime}
                      </span>
                    </div>
                    <Link 
                      to={`/article/${article.id}`}
                      className="bg-primary-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-primary-700 transition transform hover:scale-105 shadow-lg"
                    >
                      Read More →
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20" style={{ backgroundColor: '#FF6B6B' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 md:p-12 shadow-2xl border border-white/20">

            <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4 drop-shadow-lg">
              Get Weekly Spanish Tips
            </h2>
            <p className="text-lg text-white/90 mb-8 drop-shadow">
              Join 10,000+ learners receiving expert tips, resources, and exclusive content every week
            </p>
            <form 
              onSubmit={handleNewsletterSubmit}
              className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                required
                placeholder="Enter your email"
                disabled={isSubmitting}
                className="flex-1 px-6 py-4 rounded-xl border-2 border-white/30 bg-white/20 backdrop-blur text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent text-lg"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-white text-primary-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-primary-50 transition-all shadow-xl transform hover:scale-105 disabled:opacity-50"
              >
                {isSubmitting ? 'Sending...' : 'Subscribe'}
              </button>
            </form>
            <p className="text-sm text-white/80 mt-4 drop-shadow">
              Free resources  |  No spam  |  Unsubscribe anytime
            </p>
          </div>
        </div>
      </section>

      {/* Why Read Our Blog */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4">
              Why Read Our Blog?
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-primary-600 to-secondary-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-primary-50 to-secondary-50 hover:shadow-xl transition-shadow">

              <h3 className="text-xl font-display font-bold text-gray-900 mb-3">Expert Content</h3>
              <p className="text-gray-700">
                Written by native speakers and certified language instructors with years of teaching experience
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-secondary-50 to-primary-50 hover:shadow-xl transition-shadow">

              <h3 className="text-xl font-display font-bold text-gray-900 mb-3">Practical Tips</h3>
              <p className="text-gray-700">
                Actionable advice you can apply immediately to accelerate your Spanish learning journey
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-primary-50 to-secondary-50 hover:shadow-xl transition-shadow">

              <h3 className="text-xl font-display font-bold text-gray-900 mb-3">Proven Methods</h3>
              <p className="text-gray-700">
                Techniques backed by research and tested by thousands of successful Spanish learners
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Shared Footer Component */}
      <Footer />
    </div>
  );
}

export default BlogPage;